module.exports = __webpack_public_path__ + "img/icon-warn.681d7bb3.png";